const hasRegisteredAccount = (user) => Boolean(user?.uid);

export const BASIC_MAP_MARKER_ICONS = Object.freeze(['default', 'tennisBall']);

// Calendar export belongs to every registered account. Free accounts can
// choose the two basic markers; Premium unlocks the remaining styles.
export const canAddBookingsToCalendar = (user) => hasRegisteredAccount(user);
export const canChooseMapMarker = (user, accountType, markerIcon) => (
  hasRegisteredAccount(user)
  && Boolean(accountType)
  && (accountType !== 'free' || BASIC_MAP_MARKER_ICONS.includes(markerIcon))
);
